import { c as _c } from "react/compiler-runtime";
import { getEffectiveStopType } from "@/lib/stopTypes";
import { StopRow as SharedStopRow } from "@catchy/ui";
export default function StopRow(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SharedStopRow {...props} resolveStopType={_temp} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function _temp(t0) {
  const {
    stop_id,
    stop_type,
    type
  } = t0;
  return getEffectiveStopType({
    stop_id,
    stop_type
  }, type);
}